import drMarceuImg from '../assets/images/drmarceu.png';
import draPatriciaImg from '../assets/images/draPatricia.png';
import draMarianaImg from '../assets/images/draMarianaDomingues.png';
import carlaCoelhoImg from '../assets/images/carlaCoelho.png';
import vivianaRestierImg from '../assets/images/VivianaRestier.png';
import drSilasImg from '../assets/images/Silas.png';
import drLeonardoRennaImg from '../assets/images/DrleonardoRenna.png';
import draAnaCarolinaImg from '../assets/images/anacarolina.PNG';
import liviaLopesImg from '../assets/images/LiviaLopes.jpeg';

export const profissionaisData = [
  {
    nome: 'Dr. Marceu Lima',
    especialidade: 'MEDICINA FUNCIONAL INTEGRATIVA',
    genero: 'M',
    foto: drMarceuImg,
    destaque: true,
    ordemDesktop: 3,
    ordemMobile: 1,
    bio: `Médico graduado pela Universidade do Estado do Rio de Janeiro (UERJ) em 2007, com residência em Clínica Médica pelo Hospital dos Servidores do Estado e em Cardiologia pelo Instituto Nacional de Cardiologia de Laranjeiras (INCL).

Possui especialização em Imagem Cardíaca (angioTC de coronárias, ressonância magnética cardíaca e cintilografia miocárdica) e MBA em Gestão Empresarial pela FGV.

Atuou por mais de 18 anos em instituições de referência, como Hospital Copa D'Or, Hospital São Lucas e Hospital Unimed Volta Redonda, onde atualmente é rotina da Clínica Médica e também instrutor do Instituto Lóbus.

Formado em Medicina Funcional Integrativa, pela Academia Brasileira de Medicina Funcional Integrativa (ABMFI) e com imersão em Terapia Hormonal com Pellets Absorvíveis, o Dr. Marceu é Pós-Graduando em Ginecologia Clínica e Endocrinologia Feminina, com previsão de término em 2026.

Com registro profissional CRM 52 84025-4 e especialidades reconhecidas pelos RQEs 19162 - 19161, é médico responsável técnico e sócio fundador da Clínica Gerações, em Volta Redonda (RJ), unindo experiência clínica e visão integrativa para cuidar de cada paciente de forma completa.`
  },
  {
    nome: 'Dra. Patrícia Lima',
    especialidade: 'ENDOCRINOLOGISTA PEDIÁTRICA',
    genero: 'F',
    foto: draPatriciaImg,
    destaque: true,
    ordemDesktop: 2,
    ordemMobile: 2,
    bio: `A Dra. Patrícia Lima é médica formada pelo Centro Universitário de Volta Redonda (UniFOA) em 2007, com ampla experiência na área de Pediatria e Endocrinologia Pediátrica. Realizou sua residência médica em Pediatria no Hospital Federal dos Servidores do Estado do Rio de Janeiro entre 2008 e 2010, onde desenvolveu sólida base clínica e assistencial voltada ao cuidado integral da criança.

Em seguida, concluiu a residência em Endocrinologia Pediátrica na mesma instituição, entre 2010 e 2012, aprofundando seus conhecimentos no diagnóstico e tratamento de distúrbios hormonais infantis, como diabetes, obesidade, disfunções tireoidianas e distúrbios do crescimento e da puberdade.

Atualmente a Dra. Patrícia segue em constante atualização profissional, cursando Pós-graduação em Suplementação Pediátrica pela Associação Brasileira de Medicina Funcional Integrativa (ABMFI), com conclusão prevista para 2025.

Com registro profissional CRM 52 82853-0 e especialidades reconhecidas pelos RQEs 44559 e 44560, a Dra. Patrícia Lima alia conhecimento técnico, experiência clínica e uma abordagem humanizada, voltada à promoção da saúde e ao bem-estar infantil.`
  },
  {
    nome: 'Dra. Ana Carolina',
    especialidade: 'ENDOCRINOLOGISTA',
    genero: 'F',
    destaque: true,
    ordemDesktop: 1,
    ordemMobile: 3,
    foto: draAnaCarolinaImg,
    bio: `Sou Ana Carolina Moraes Mattos, médica formada pela Faculdade de Medicina de Valença (FMV-RJ) em 2018, com residência em Clínica Médica também pela Faculdade de Medicina Valença (2022) e Especialização em Endocrinologia pela Afya Educação Médica (2024).

Minha atuação é focada principalmente no tratamento da obesidade, diabetes, tireoide e distúrbios hormonais.

Acredito que saúde não se resume a prescrever medicamentos. Cada paciente carrega uma história, e por isso, cada consulta é conduzida com escuta atenta, empatia e embasamento científico - tudo para traçar um plano terapêutico personalizado e eficaz.

Cuidar do corpo é também cuidar da autoestima, da energia e da qualidade de vida. E é exatamente isso que busco oferecer em cada atendimento: um olhar completo e humano sobre sua saúde hormonal em qualquer fase da sua vida.`
  },
  {
    nome: 'Dra. Mariana Domingues',
    especialidade: 'ENDOCRINOLOGISTA',
    genero: 'F',
    foto: draMarianaImg,
    destaque: true,
    ordemDesktop: 4,
    ordemMobile: 4,
    bio: `Dra. Mariana Domingues é médica endocrinologista e clínica geral, formada pela Faculdade UniFOA de Volta Redonda em 2011. Realizou residência em Clínica Médica no Hospital Estadual Luiz Gioseffi Jannuzzi (HELGJ) em parceria com a Fundação Educacional Dom André Arcoverde (FAA), concluída em 2016. Posteriormente fez residência em Endocrinologia e Metabologia pela Universidade Federal Fluminense (UFF) no Hospital Antônio Pedro, finalizando em 2020.

Com registro profissional CRM 920401 – RJ e RQE 34085, a Dra. Mariana atua com foco na prevenção, diagnóstico e tratamento de distúrbios hormonais e metabólicos, oferecendo um acompanhamento personalizado e humanizado aos pacientes.

Suas principais especialidades incluem Diabetologia, Obesidade, Patologias da Tireoide e Reposição Hormonal.

Entre as doenças tratadas, destacam-se: Diabetes, Osteoporose, Dislipidemias, Obesidade, Hipotireoidismo, Doenças da hipófise, Hipertireoidismo, Nódulos da glândula tireoide, Diabetes gestacional, Lipedema e tratamentos para emagrecimento saudável.

A Dra. Mariana acredita em uma medicina baseada na escuta ativa, na atualização constante e na busca pelo equilíbrio entre corpo e mente, promovendo saúde e qualidade de vida a longo prazo.`
  },
  {
    nome: 'Dra. Carla Coelho',
    especialidade: 'NUTRICIONISTA',
    genero: 'F',
    foto: carlaCoelhoImg,
    destaque: true,
    ordemDesktop: 5,
    ordemMobile: 5,
    bio: `Carla Coelho é nutricionista graduada pelo Centro Universitário de Volta Redonda (UniFOA) em 2021. Apaixonada por saúde, movimento e bem-estar, traz em sua trajetória a disciplina e a dedicação adquiridas como ex-bailarina, além de ser entusiasta do CrossFit e da corrida.

Concluiu pós-graduação em Nutrição Clínica e Funcional pela Universidade Federal do Rio de Janeiro (UFRJ) em 2021, aprofundando seus conhecimentos na abordagem personalizada da nutrição, voltada à saúde metabólica, digestiva e hormonal.

Atualmente é pós-graduanda em Nutrição Funcional e Integrativa pela Academia de Medicina Funcional e Integrativa, com conclusão prevista para 2025, ampliando sua atuação para uma visão mais completa e integrativa do cuidado nutricional.

Com uma abordagem centrada no indivíduo, Carla Coelho alia ciência, prática e empatia para promover mudanças reais e sustentáveis nos hábitos alimentares, ajudando seus pacientes a conquistarem mais energia, equilíbrio e qualidade de vida.`
  },
  {
    nome: 'Dr. Leonardo Renna',
    especialidade: 'GASTROENTEROLOGISTA',
    genero: 'M',
    foto: drLeonardoRennaImg,
    bio: `O Dr. Leonardo Renna é médico formado pela Universidade do Grande Rio (UNIGRANRIO), com especialização em Clínica Médica pelo Hospital Federal Cardoso Fontes e em Gastroenterologia pelo Instituto de Assistência Médica ao Servidor Público Estadual de São Paulo (IAMSPE).

Aperfeiçoou-se em Doença Inflamatória Intestinal — abrangendo Doença de Crohn e Retocolite Ulcerativa — no Hospital Nossa Senhora da Oliveira, em Portugal, consolidando sua experiência em diagnósticos e tratamentos avançados nessa área.

Atua como médico clínico hospitalista e emergencista no Hospital Unimed Volta Redonda e como médico de rotina no Hospital São João Batista, também em Volta Redonda. Além disso, exerce a função de preceptor do internato da Faculdade de Medicina do UniFOA, contribuindo para a formação de novos profissionais da saúde.

Com registro profissional CRM RJ 922560 e especialidades reconhecidas pelos RQEs 34147 e 34146, o Dr. Leonardo Renna é especialista em Gastroenterologia e Hepatologia, com atuação destacada nas áreas de Hepatologia, Doença Celíaca, Doença Inflamatória Intestinal e Gastroenterologia do Adulto.`
  },
  {
    nome: 'Dr. Silas Tavares',
    especialidade: 'PSIQUIATRA',
    genero: 'M',
    foto: drSilasImg,
    bio: `O Dr. Silas Tavares é médico formado pela Faculdade de Medicina de Valença (RJ) e pós-graduado em Psiquiatria pelo Centro Brasileiro de Pós-Graduações, em São Paulo (SP). Complementou sua formação com estudos em Filosofia Aplicada pelo Instituto de Cultura e Inteligência Moral (ICIM), o que ampliou sua visão sobre o comportamento humano e a essência da saúde mental.

Com ampla experiência clínica e mais de 2.000 pacientes atendidos, o Dr. Silas Tavares atua com uma vocação clara: compreender o sofrimento humano e resgatar o que realmente importa. Sua prática é guiada pela escuta empática e pelo entendimento de que "a cura da alma vai muito além dos remédios".

Unindo conhecimento científico e sensibilidade, o Dr. Silas Tavares oferece um cuidado integral e humanizado, voltado ao equilíbrio emocional e ao bem-estar do paciente.`
  },
  {
    nome: 'Dra. Viviana Restier',
    especialidade: 'DRENAGEM LINFÁTICA',
    genero: 'F',
    foto: vivianaRestierImg,
    bio: `Dra. Viviane Restier é fisioterapeuta, formada pela Universidade Católica de Petrópolis (UCP) em 1996, com ampla experiência em reabilitação e estética corporal.

Ao longo de sua carreira, buscou constante aprimoramento profissional por meio de cursos especializados, incluindo Drenagem Linfática, Kinesio Tape e Drenagem e Enfaixamento para Linfedema, aprimorando suas técnicas de cuidado e recuperação funcional.

Com uma atuação pautada na atenção individualizada e na promoção do bem-estar, a Dra. Viviane Restier alia conhecimento técnico e sensibilidade humana para oferecer tratamentos eficazes e personalizados, voltados à melhora da qualidade de vida e equilíbrio corporal de seus pacientes.`
  },
  {
    nome: 'Lívia Lopes',
    especialidade: 'FISIOTERAPIA PÉLVICA E VASCULAR',
    genero: 'F',
    foto: liviaLopesImg,
    bio: `Lívia Lopes é fisioterapeuta há mais de 20 anos, com especialização em Fisioterapia Pélvica, Uroginecologia e Obstetrícia. Ao longo de sua trajetória, construiu ampla experiência no cuidado à saúde da mulher, acompanhando suas necessidades nas diferentes fases da vida.

Atua também na fisioterapia vascular, com foco no tratamento conservador do lipedema e do linfedema, além de alterações relacionadas ao edema e à circulação. Seu trabalho integra recursos terapêuticos e tecnologias a uma abordagem individualizada, baseada nas necessidades de cada paciente.

Sua atuação é pautada no conhecimento científico, na escuta e no acolhimento, respeitando a história, as particularidades e os objetivos de cada mulher. Acredita no cuidado humanizado e na atuação multiprofissional como caminhos para promover saúde, funcionalidade e qualidade de vida.`
  }
];

export const WHATSAPP_NUMBER = '5524988345771';
